/**
 * Global SWR fetcher.
 *
 * Extracted from index.tsx into its own module so it can be imported by tests
 * without bootstrapping the full React application.
 *
 * Background: SWR v2 removed the built-in default fetcher that v0.5 provided.
 * Without a fetcher supplied to <SWRConfig>, every useSWR() call that omits a
 * per-call fetcher returns { data: undefined, error: undefined } forever,
 * causing infinite loading states.
 */
export const swrFetcher = (url: string): Promise<unknown> => fetch(url).then((r) => r.json())

